<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
        <el-button @click="_closeAddProduct()">返回</el-button>
      </div>
      <div class="">
        <el-form :model="editChainProductInfo" :rules="rules" ref="form" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品名称" prop="prodName">
                <el-input v-model="editChainProductInfo.prodName" placeholder="必填，请填写商品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品分组" prop="catalogId">
                <el-select v-model="editChainProductInfo.catalogId" style="width:100%">
                  <el-option label="必填，请选择商品分组" value="" disabled></el-option>
                  <el-option v-for="(item, index) in chainCatalogs" :key="index"
                    :label="item.catalogName" :value="item.catalogId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位" prop="unitName">
                <el-input v-model="editChainProductInfo.unitName" placeholder="选填，请填写单位"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="editChainProductInfo.sort" placeholder="选填，请填写排序"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品简介" prop="prodDesc">
                <el-input type="textarea" :rows="3" v-model="editChainProductInfo.prodDesc" placeholder="必填，请填写商品简介"
                  maxlength="250">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品图片</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品封面">
                <upload-image-url ref="coverImageUpload" :image-count="1"
                  @notifyUploadCoverImage="handleCoverImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品轮播">
                <upload-image-url ref="carouselImageUpload" :image-count="3"
                  @notifyUploadCoverImage="handleCarouselImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品规格</span>
        <el-button type="primary" size="small" @click="_editChainProductSpec()">
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>
      <div class="">
        <el-table :data="editChainProductInfo.productSpecs" border style="width:100%">
          <el-table-column prop="specName" label="规格名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specName" placeholder="请输入规格名称"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="specValue" label="规格值" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specValue" placeholder="请输入规格值"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.price" :precision="2" :min="0"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="barCode" label="条形码" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.barCode" placeholder="请输入条形码"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="_openAddDeleteProductSpec(scope.row)">
                删除
              </el-button>
              <el-button v-if="scope.row.isDefault != 'T'" type="primary" size="mini"
                @click="_doEditDefaultProductSpec(editChainProductInfo, scope.row)">
                默认规格
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品扩展</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品状态">
                <el-select v-model="editChainProductInfo.state" style="width:100%">
                  <el-option label="选填，请选择状态" value="" disabled></el-option>
                  <el-option label="未上架" value="1001"></el-option>
                  <el-option label="上架" value="2002"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品详情">
                <RichTextEditor ref="richTextEditor" v-model="editChainProductInfo.content" @input="handleContentChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="margin-top:20px;text-align:right;">
          <el-button type="warning" @click="_closeAddProduct()">
            取消
          </el-button>
          <el-button type="primary" @click="updateProductInfo()">
            <i class="el-icon-check"></i>保存
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
import RichTextEditor from '@/components/system/RichTextEditor.vue'
import { getDict } from '@/api/shop/shopApi'
import { listChainSupplierCatalog } from '@/api/admin/chainSupplierCatalog/chainSupplierCatalogApi'
import { listChainProduct, updateChainProduct } from '@/api/admin/chainProduct/chainProductApi'

export default {
  name: 'EditChainProduct',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      editChainProductInfo: {
        productId: '',
        catalogId: '',
        prodName: '',
        prodDesc: '',
        unitName: '',
        sort: '',
        content: '',
        states: [],
        state: '',
        coverPhoto: '',
        carouselFigurePhotos: [],
        productSpecs: [],
        areaCode: '',
        csId: ''
      },
      chainCatalogs: [],
      rules: {
        catalogId: [
          { required: true, message: '商品大类不能为空', trigger: 'change' }
        ],
        prodName: [
          { required: true, message: '商品名称不能为空', trigger: 'blur' },
          { max: 128, message: '商品名称不能超过128位', trigger: 'blur' }
        ],
        prodDesc: [
          { required: true, message: '商品简介不能为空', trigger: 'blur' },
          { max: 256, message: '商品简介不能超过256位', trigger: 'blur' }
        ],
        unitName: [
          { max: 32, message: '单位不能超过32位', trigger: 'blur' }
        ],
        sort: [
          { pattern: /^\d+$/, message: '排序格式错误', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.editChainProductInfo.productId = this.$route.query.productId || ''
    this.editChainProductInfo.csId = this.$route.query.csId || ''
    this.initData()
  },
  methods: {
    async initData() {
      try {
        // 获取字典数据
        const { data: dictData } = await getDict('product', 'state')
        this.editChainProductInfo.states = dictData

        // 获取商品分类列表
        this._listEditCatalogs()

        // 加载商品详情
        this._listProducts()
      } catch (error) {
        console.error('初始化数据失败:', error)
      }
    },

    handleCoverImageUpload(param) {
      if (param.length > 0) {
        this.editChainProductInfo.coverPhoto = param[0]
      } else {
        this.editChainProductInfo.coverPhoto = ''
      }
    },

    handleCarouselImageUpload(param) {
      this.editChainProductInfo.carouselFigurePhotos = []
      param.forEach(p => {
        this.editChainProductInfo.carouselFigurePhotos.push(p)
      })
    },

    handleContentChange(content) {
      this.editChainProductInfo.content = content
    },

    editProductValidate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid)
        })
      })
    },

    async updateProductInfo() {
      try {
        // 检查是否有默认规格
        const flag = this.editChainProductInfo.productSpecs.some(spec => spec.isDefault === 'T')
        if (!flag && this.editChainProductInfo.productSpecs.length > 0) {
          this.$message.warning('未选择默认规格')
          return
        }

        // 表单验证
        const valid = await this.editProductValidate()
        if (!valid) {
          return
        }

        const res = await updateChainProduct(this.editChainProductInfo)
        if (res.code == 0) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存商品失败:', error)
        this.$message.error('保存商品失败')
      }
    },

    async _listProducts() {
      try {
        const params = {
          page: 1,
          row: 1,
          productId: this.editChainProductInfo.productId,
          csId: this.editChainProductInfo.csId
        }
        const res = await listChainProduct(params)
        
        if (res.code == 404) {
          this.$message.error('请检查供应链信息是否正确。')
          return
        }

        if (res.data && res.data.length > 0) {
          const product = res.data[0]
          
          // 复制商品数据
          Object.assign(this.editChainProductInfo, {
            productId: product.productId || '',
            catalogId: product.catalogId || '',
            prodName: product.prodName || '',
            prodDesc: product.prodDesc || '',
            unitName: product.unitName || '',
            sort: product.sort || '',
            content: product.content || '',
            state: product.state || '',
            coverPhoto: product.coverPhoto || '',
            carouselFigurePhotos: product.carouselFigurePhotos || [],
            productSpecs: product.chainProductValueDtos || [],
            csId: product.csId || this.editChainProductInfo.csId
          })

          // 设置封面图
          if (product.coverPhoto) {
            this.$nextTick(() => {
              this.$refs.coverImageUpload && this.$refs.coverImageUpload.setImages([product.coverPhoto])
            })
          }

          // 设置轮播图
          if (product.carouselFigurePhotos && product.carouselFigurePhotos.length > 0) {
            this.$nextTick(() => {
              this.$refs.carouselImageUpload && this.$refs.carouselImageUpload.setImages(product.carouselFigurePhotos)
            })
          }

          // 设置商品详情
          if (product.content) {
            this.$nextTick(() => {
              this.$refs.richTextEditor && this.$refs.richTextEditor.setContent(product.content)
            })
          }
        }
      } catch (error) {
        console.error('获取商品详情失败:', error)
        this.$message.error('获取商品详情失败')
      }
    },

    _closeAddProduct() {
      this.$router.go(-1)
    },

    async _listEditCatalogs() {
      try {
        const params = {
          page: 1,
          row: 50,
          csId: this.editChainProductInfo.csId
        }
        const res = await listChainSupplierCatalog(params)
        this.chainCatalogs = res.data || []
      } catch (error) {
        console.error('获取商品分类失败:', error)
      }
    },

    _editChainProductSpec() {
      const productSpec = {
        specName: '',
        specValue: '',
        price: 0,
        barCode: '',
        isDefault: 'F'
      }

      this.editChainProductInfo.productSpecs.push(productSpec)

      // 如果没有默认规格，设置第一个为默认
      const flag = this.editChainProductInfo.productSpecs.some(spec => spec.isDefault === 'T')
      if (!flag && this.editChainProductInfo.productSpecs.length > 0) {
        this.editChainProductInfo.productSpecs[0].isDefault = 'T'
      }
    },

    _openAddDeleteProductSpec(productSpec) {
      const index = this.editChainProductInfo.productSpecs.indexOf(productSpec)
      if (index > -1) {
        this.editChainProductInfo.productSpecs.splice(index, 1)
      }

      // 如果没有默认规格，设置第一个为默认
      const flag = this.editChainProductInfo.productSpecs.some(spec => spec.isDefault === 'T')
      if (!flag && this.editChainProductInfo.productSpecs.length > 0) {
        this.editChainProductInfo.productSpecs[0].isDefault = 'T'
      }
    },

    _doEditDefaultProductSpec(product, defaultProductSpec) {
      product.productSpecs.forEach(item => {
        item.isDefault = 'F'
      })
      defaultProductSpec.isDefault = 'T'
      this.editChainProductInfo.productSpecs = JSON.parse(JSON.stringify(product.productSpecs))
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
  align-items: center;
}
</style>

